var React = require('react');

function SortUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0L11.1962 9L0.803848 9L6 0Z","fill":"white"}));
}

SortUp.defaultProps = {"width":"12","height":"9","viewBox":"0 0 12 9"};

module.exports = SortUp;

SortUp.default = SortUp;
